/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import classNames from 'classnames';
import Signals from '../../../signals/Signals';
import { Routes } from '../../../data/Routes';

import SearchField from '../../../components/ui/SearchField/SearchField';
import Page from '../../Page';
import PeriodicInvoicesRow from './components/PeriodicInvoicesRow';
import AddButton from '../../../components/ui/AddButton/AddButton';

import { ApplicationContext } from '../../../ApplicationContext';
import GetPeriodicInvoicesConceptCommand from '../../../commands/periodicInvoiceConcepts/GetPeriodicInvoicesConceptCommand';
import PeriodicInvoicesConceptStore from '../../../stores/PeriodicInvoicesConceptStore';
import TableWrapper from '../../../components/ui/TableWrapper/TableWrapper';

/**
 *
 */
@observer
class PeriodicInvoices extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.addNew = this.addNew.bind(this);
		this.onSortClick = this.onSortClick.bind(this);
		this.onCompanyChanged = this.onCompanyChanged.bind(this);

		//
		this.fieldHeaderSettings = [
			{
				id: 'status',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.status' }),
				isDefault: true,
				minimal: true
			},
			{
				id: 'lastattempt',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.lastattempt' }),
				isDefault: false,
				minimal: true
			},
			{
				id: 'interval',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.period' }),
				isDefault: false,
				minimal: true
			},
			// {id: 'paid', label: this.props.intl.formatMessage({id:'invoices.header.paid'}), minimal:true},
			{
				id: 'date',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.next' }),
				minimal: true
			},
			{
				id: 'companyName',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.client' })
			},
			{
				id: 'subject',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.subject' })
			},
			{
				id: 'send',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.send' }),
				minimal: true,
				center: true
			},
			{
				id: 'amount',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.amount' }),
				right: true,
				minimal: true
			},
			{
				id: 'actions',
				label: this.props.intl.formatMessage({ id: 'invoices.periodic.header.actions' }),
				center: true,
				noSort: true,
				minimal: true
			}
		];

		//
		this.state = {};
	}

	/**
	 *
	 */
	componentWillMount() {
		Signals.CompanyChanged.add(this.onCompanyChanged);
		this.onCompanyChanged();
	}

	/**
	 *
	 */
	componentWillUnmount() {
		Signals.CompanyChanged.remove(this.onCompanyChanged);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const company = this.context.applicationStore.getSelectedCompany();
		if (!company) {
			return null;
		}

		// Create table headers
		const headers = this.fieldHeaderSettings.map((fieldData, index) => {
			if (fieldData.hide) return null;

			return (
				<td
					key={`ih-${index}`}
					className={`periodic-invoices__header--${`${fieldData.id}`.toLowerCase()} ${classNames({
						table__header: true,
						'table__header--minimal': fieldData.minimal,
						'table__header--sorted-default table__header--sorted':
							!this.props.periodicInvoicesConceptStore.sortBy && fieldData.isDefault,
						'table__header--sorted':
							this.props.periodicInvoicesConceptStore.sortBy === fieldData.id,
						'table__header--sorted-up':
							this.props.periodicInvoicesConceptStore.sortBy === fieldData.id &&
							this.props.periodicInvoicesConceptStore.sortDirection === -1,
						'table__header--center': fieldData.center,
						'table__header--right': fieldData.right,
						'table__header--no-sort': fieldData.noSort
					})}`}
					onClick={() => this.onSortClick(fieldData.id)}>
					{fieldData.label}
				</td>
			);
		});

		// Create invoices rows
		const rows = this.props.periodicInvoicesConceptStore.filteredAndSortedInvoiceConcepts.map(
			(periodicInvoiceConceptModel) => {
				// Ignore if not an 'open' invoice
				if (this.props.showOpenOnly && !periodicInvoiceConceptModel.isOpen()) {
					return null;
				}

				return (
					<PeriodicInvoicesRow
						key={`pi-${periodicInvoiceConceptModel.id}`}
						periodicInvoiceConceptModel={periodicInvoiceConceptModel}
					/>
				);
			}
		);

		return (
			<Page pageName="periodic-invoices">
				<div className="periodic-invoices__wrapper border border--dark">
					<div className="periodic-invoices__options box-shadow-small grid grid--spread">
						<div className="grid periodic-invoices__options__left">
							<SearchField
								name="search"
								className="btn-margin-right"
								// eslint-disable-next-line react/jsx-no-bind
								onChange={this.onSearch.bind(this)}
								placeholder={this.props.intl.formatMessage({ id: 'invoices.search' })}
								value={
									this.props.periodicInvoicesConceptStore.searchFilter
										? this.props.periodicInvoicesConceptStore.searchFilter
										: undefined
								}
							/>
						</div>
						<div className="grid periodic-invoices__options-buttons">
							<button
								type="button"
								className="periodic-invoices__add-new icon icon--left icon--big-plus icon--color"
								onClick={this.addNew}>
								<FormattedMessage id="invoices.periodic.add.invoice" />
							</button>
						</div>
					</div>

					<TableWrapper scrollableX>
						<table className="table">
							<thead className="table__headers">
								<tr>{headers}</tr>
							</thead>
							<tbody className="table__body">{rows}</tbody>
						</table>
					</TableWrapper>

					<div className="table__footer periodic-invoices__footer options-footer grid grid--spread border--top" />
					<AddButton
						onClick={this.addNew}
						title={this.props.intl.formatMessage({ id: 'invoices.add.invoice' })}
					/>
				</div>
			</Page>
		);
	}

	/**
	 *
	 */
	onCompanyChanged() {
		const company = this.context.applicationStore.getSelectedCompany();
		if (company) {
			const command = new GetPeriodicInvoicesConceptCommand(
				this.props.periodicInvoicesConceptStore,
				company.id
			);
			command.execute();
		}
	}

	/**
	 *
	 * @param e
	 */
	onSearch(e) {
		this.props.periodicInvoicesConceptStore.searchFilter = e ? e.target.value : null;
	}

	/**
	 *
	 * @param field
	 */
	onSortClick(field) {
		if (this.props.periodicInvoicesConceptStore.sortBy === field) {
			this.props.periodicInvoicesConceptStore.sortDirection =
				-this.props.periodicInvoicesConceptStore.sortDirection;
		} else {
			this.props.periodicInvoicesConceptStore.sortBy = field;
			this.props.periodicInvoicesConceptStore.sortDirection = 1;
		}
	}

	/**
	 *
	 */
	addNew() {
		const company = this.context.applicationStore.getSelectedCompany();
		if (company) {
			Signals.RequestRoute.dispatch(
				Routes.COMPANY_INVOICES_PERIODIC_EDIT.getPath({ id: company.id, invoiceId: 'new' })
			);
		}
	}

	/**
	 *
	 * @param field
	 * @return {*}
	 * @private
	 */
	// eslint-disable-next-line react/no-unused-class-component-methods
	_getHeaderLabel(field) {
		const result = this.fieldHeaderSettings.find((fieldData) => {
			return fieldData.id === field;
		});

		return result ? result.label : field;
	}
}

PeriodicInvoices.contextType = ApplicationContext;

PeriodicInvoices.propTypes = {
	intl: PropTypes.object,
	showOpenOnly: PropTypes.bool,
	periodicInvoicesConceptStore: PropTypes.instanceOf(PeriodicInvoicesConceptStore).isRequired
};

PeriodicInvoices.defaultProps = {
	showOpenOnly: false
};

export default injectIntl(PeriodicInvoices);
